/**
 * ownGoalTeam — EPIC-98 (item 5/AC5). An own goal's `data.own_goal === true`
 * Shot dispatches with `team_id` = the BENEFITING team and `player_id` = the
 * CONCEDING player (`useActionFlow.ts`'s `handleQuickActionSelect("OwnGoal")`,
 * unchanged by this epic — see `usePlayerStats.ts`'s own doc comment on the
 * same shape). Naming "whose own goal this is" therefore requires a roster
 * lookup: the conceding player's OWN team is whichever roster
 * (`match.home_team`/`away_team`) actually lists their id, not `event.team_id`
 * (that's the other side). Shared by `GoalPlacementOverlay.tsx` (the live
 * goal-frame header) and, per this UC, the review/feed placement editor.
 */
import type { Match, Team } from "../types";

/** Returns the team (home or away) whose roster contains `playerId`, or
 * `null` when neither roster has loaded them yet (defensive — a stale/
 * incomplete roster must never crash the header, just omit the crest). */
export function findPlayerTeam(
  playerId: string | undefined,
  match: Match,
): Team | null {
  if (!playerId) return null;
  if (match.home_team.players.some((p) => p.id === playerId)) {
    return match.home_team;
  }
  if (match.away_team.players.some((p) => p.id === playerId)) {
    return match.away_team;
  }
  return null;
}
